import { jsx as _jsx } from "react/jsx-runtime";
export const SchematicNodeContainer = ({ width, height, rotation, children }) => {
    return _jsx("div", { style: { position: 'relative', width, height, rotate: rotation ? `${rotation}rad` : undefined }, children: children });
};
